import { render, staticRenderFns } from "./Gerenzhongxin.vue?vue&type=template&id=1c6b50ef&"
import script from "./Gerenzhongxin.vue?vue&type=script&lang=js&"
export * from "./Gerenzhongxin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports